import { keys } from '@/injection-keys'

export function useOptions() {
  const options = inject(keys.options)

  if (!options) {
    throw new Error('useOptions() is called without options')
  }

  return options
}
